import flatpickr from 'flatpickr';
import React from 'react';

import { EntitySearchHolder } from '~/components/entity-search/entity-search-holder/entity-search-holder';
import { DateFormatValueConverter } from '~/converters/date-format';
import { FlatpickrUtils } from '~/utils/flatpickr-utils';
import { Key } from '~/utils/key';

import inputStyles from '~/components/entity-search/entity-search-input/entity-search-input.module.scss';

interface Props {
	label: string;
	name: string;
	title: string;
	onChange: (value: string | undefined) => void;
	value: string;
}

export class EntitySearchDatepicker extends React.Component<Props> {
	private readonly refInputEl = React.createRef<HTMLInputElement>();

	private flatpickrUtils?: FlatpickrUtils;

	public componentDidMount() {
		if (!this.refInputEl.current) {
			throw new Error('Missing <input>');
		}
		this.flatpickrUtils = new FlatpickrUtils(this.refInputEl.current, {
			onChange: this.onFlatpickrChange,
		});
	}

	public componentWillUnmount() {
		this.flatpickrUtils.unmount();
	}

	public componentDidUpdate(prevProps: Props, prevState, snapshot) {
		if (
			this.props.hasOwnProperty('value') &&
			prevProps.value !== this.props.value
		) {
			this.flatpickrUtils.flatpickr.setDate(
				DateFormatValueConverter.toLocaleDate(this.props.value),
				false,
			);
		}
	}

	private readonly onFlatpickrChange = (value: string | undefined): void => {
		this.props.onChange(value);
	};

	private onIconClick = (e: React.MouseEvent): void => {
		if (this.flatpickrUtils.flatpickr) {
			this.flatpickrUtils.flatpickr.open();
		}
	};

	public render() {
		const { label, name, onChange, value, title } = this.props;
		return (
			<EntitySearchHolder label={label} name={name} title={title}>
				<input
					type="text"
					id={name}
					name={name}
					className={inputStyles.input}
					defaultValue={value}
					ref={this.refInputEl}
				/>
				<button
					type="button"
					className={[
						'field-holder__button-reset',
						inputStyles.icon,
					].join(' ')}
					onClick={this.onIconClick}
					tabIndex={-1}
				>
					<i className="far fa-calendar-alt" />
				</button>
			</EntitySearchHolder>
		);
	}
}
